import type { FillInDaBlanksValues } from "@endgame/utils/fillInDaBlanks";

import { fillInDaBlanks } from "@endgame/utils/fillInDaBlanks";

export const errorMessages = {
  zeytalApiError500: () =>
    "We couldn’t contact our API or it returned a 500 error.\nCheck your internet connection.\nContact the support if this lasts.",

  zeytalApiNoData: () =>
    "No project data returned by our API.\nEnsure you have passed a valid project secret token.\n Check zeytal.com/docs for more info about secret project tokens.",

  noFigmaApiKey: (values: FillInDaBlanksValues) =>
    fillInDaBlanks(
      `No figma personal token found for project {projectName}.\nAdd it in your project dashboard on zeytal.com`,
      values,
    ),

  undefinedCreateFolderDir: () => "No directory specified for createFolder()!",

  undefinedRefreshPath: () => "No path provided to refreshFolder()!",

  writingFile: () => "Error while attempting to write file(s)!",
};
